module.exports = __webpack_public_path__ + "img/64.959bacfe.gif";